import { HorizontalRail } from "../../design-v2";

function isSameSelection(left, right) {
  return String(left) === String(right);
}

export default function DayRail({ workouts = [], selectedWorkoutOrderIndex, onSelect }) {
  return (
    <HorizontalRail
      className="lz-product-rail lz-product-day-rail"
      aria-label="Day selection"
      activeItem={selectedWorkoutOrderIndex}
      snap="start"
    >
      {workouts.length === 0 ? (
        <span className="lz-product-day-rail__empty">No scheduled days</span>
      ) : workouts.map((workout) => {
        const isActive = isSameSelection(
          workout.orderIndex,
          selectedWorkoutOrderIndex
        );
        return (
          <button
            className={`lz-product-day-button${isActive ? " lz-product-day-button--active" : ""}`}
            type="button"
            key={workout.id || workout.orderIndex}
            data-rail-item={workout.orderIndex}
            aria-label={`Day ${workout.orderIndex}: ${workout.name}`}
            aria-current={isActive ? "true" : undefined}
            onClick={() => onSelect?.(workout.orderIndex)}
          >
            <span className="lz-product-day-button__identity">D{workout.orderIndex}</span>
            <span className="lz-product-day-button__name">{workout.name}</span>
          </button>
        );
      })}
    </HorizontalRail>
  );
}
